<script setup lang="ts" generic="T">
import { inject } from 'vue';
import { sectionNavRegistryKey } from './internal';
import type { DomRegistryItem } from './createDomRegistry';

// Renderless: the consumer owns the markup (a scrubber rail / table-of-contents).
// The slot yields the DOM-ordered items (each with index, active, scrollIntoView)
// and the current activeId.
defineSlots<{
  default(props: { items: DomRegistryItem<T>[]; activeId: string | null }): unknown;
}>();

const registry = inject(sectionNavRegistryKey);
if (!registry) throw new Error('[nx-ui] SectionNavList must be used inside SectionNavRoot');
</script>

<template>
  <slot
    :items="registry.items.value as DomRegistryItem<T>[]"
    :active-id="registry.activeId.value"
  />
</template>
